import {Backbone} from 'Vertebrae';
import {Industry} from '../model/industry';

export const Industries = Backbone.Collection.extend({
    _name: 'Industries',
    model: Industry,
});
